import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _postscriptShopId: {
      type: "string",
      name: "Postscript Shop Id",
      description: "Found in Postscript dashboard in the 'Shop Settings'",
      defaultValue: null,
    },
    _postscriptKeywordId: {
      type: "string",
      name: "Postscript Keyword Id",
      description:
        "Found in Postscript dashboard in 'Acquisition' -> 'Keywords'",
      defaultValue: null,
    },
  };
}

const styleElements = {
  root: {},
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: false,
    customProps: convertToLegacyProps(getConfigurableProps()),
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
